export default __webpack_public_path__ + "4b6148f72e5cfd7a79478953031ffee1.svg";